import { AtlasButtonProps, Button } from "@resource/atlas";
import { atlasCalendarEvents } from "@resource/atlas/icons";
import { useLogEvent } from "analytics";
import { LexicalEditor } from "lexical";
import { useCallback } from "react";
import { DEFAULT_DATA as REQUEST_AVAILABILITY_DEFAULT_DATA } from "shared/guide-content/rich-blocks/request-availability";

import { INSERT_REQUEST_AVAILABILITY_COMMAND } from "./rich-block";

type UseRequestAvailabilityProps = {
  editor: LexicalEditor;
  logEvent?: ReturnType<typeof useLogEvent>;
  timezone?: string | null;
};

export function useInsertRequestAvailability({
  editor,
  timezone,
  logEvent,
}: UseRequestAvailabilityProps) {
  const InsertButton = useCallback(
    (props?: Omit<Partial<AtlasButtonProps>, "onClick" | "icon">) => (
      <Button
        {...props}
        icon={atlasCalendarEvents}
        onClick={() => {
          logEvent?.("Request Availability Quick Action Clicked", {
            customerSuccess: true,
          });
          editor.focus();
          editor.dispatchCommand(INSERT_REQUEST_AVAILABILITY_COMMAND, {
            ...REQUEST_AVAILABILITY_DEFAULT_DATA,
            timezone:
              timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
          });
        }}
      >
        Request availability
      </Button>
    ),
    [editor, logEvent, timezone]
  );

  return {
    InsertButton,
  };
}
